import { useInstance } from 'intact-vue-next';
import dayjs from 'dayjs';
import { isEqual } from './helpers';
import { _$ } from '../../i18n';
export function useMonths(showDate, status, focusDate) {
  var instance = useInstance();
  function getMonths(now) {
    var ret = [];
    var start = showDate.value.toDate();
    start.setMonth(0);
    for (var i = 0; i < 12; i++) {
      var dayjsDate = dayjs(start);
      ret.push({
        isActive: status.isActive(dayjsDate, 'month'),
        isToday: dayjsDate.isSame(now, 'month'),
        isDisabled: status.isDisabled(dayjsDate),
        isHover: isEqual(dayjsDate, focusDate.value, 'month'),
        isInRange: status.isInRange(dayjsDate, 'month'),
        label: _$(i + 1 + '月'),
        value: dayjsDate
      });
      start.setMonth(i + 1);
    }
    return ret;
  }
  function onClick(date) {
    showDate.set(date);
    var datepickerType = instance.datepicker.get('type');
    if (datepickerType !== 'month' && datepickerType !== 'year') {
      instance.type.set('date');
    } else {
      instance.triggerChange(date);
    }
  }
  return {
    getMonths: getMonths,
    onClick: onClick
  };
}